import store from '@/store/store';
import { Route } from 'vue-router';

import { tryParseInt } from './number';
import { prepareQuery } from './prepareQuery';

/**
 * Przygotowuje zapytanie dla paczek dokumentu
 *
 * @export
 * @param {Route} route
 * @returns {*}
 */
export function prepareDocumentPackQuery(route: Route): any {
  return {
    ...prepareQuery(route),
    count: -1,
    order: route.query?.order?.includes('.') ? undefined : (route.query.order as string),
    procedureId: tryParseInt(route.params.procedureId),
    status: route.query.status,
    structureIds: store.state.auth.nodes?.map((node: any) => node.id)
  };
}
